import React from 'react';
import { Router } from 'react-router-dom';

import { History } from 'history';

interface AppRouterProps {
  basename: string;
  children: React.ReactChild;
  history: History;
}

export const AppRouter: React.FC<AppRouterProps> = ({ basename, children, history }) => {
  const [state, setState] = React.useState({
    action: history.action,
    location: history.location,
  });

  React.useLayoutEffect(() => history.listen(setState), [history]);

  return (
    <Router
      basename={basename}
      children={children}
      location={state.location}
      navigationType={state.action}
      navigator={history}
    />
  );
};
